import React, { ReactElement, useEffect } from 'react';

import {
  Container,
  Paragraph,
  Notification,
  Grid,
  ButtonPattern,
  ListItem,
  List,
  Text,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import PageHeading from 'components/pageHeading/PageHeading';
import {
  StyledContainer,
  StyledGridItem,
  StyledOuterContentGroup,
} from 'components/registrationSteps/RegistrationSteps.styled';
import StyledBox from 'components/style/styledBox/StyledBox';
import { Button, Link } from 'components/tagging';
import dataQaIds from 'dataModel/dataQaIds';

import { MayfairAccountErrorContent } from './MayfairAccountErrorContent';
import { JOURNEY_STEPS, LINK_EVENT } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';

function MayfairAccountError(): ReactElement {
  const { mayfairAccountErrorContent } =
    useContent<MayfairAccountErrorContent>();
  useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION
        .ABOUT_THE_BUSINESS_MAYFAIR_ACCOUNT_ERROR,
    );
  }, []);

  return (
    <Container padding="none">
      {mayfairAccountErrorContent?.map(
        ({
          serviceName,
          header,
          errorHeader,
          errorSummary,
          stepsHeader,
          stepOne,
          stepOneHref,
          stepTwo,
          stepThree,
          backBtnLabel,
          backBtnHref,
        }) => (
          <React.Fragment key="content">
            <PageHeading serviceName={serviceName} header={header} />
            <StyledContainer marginBottom="06">
              <Grid alignY="center">
                <StyledGridItem>
                  <StyledOuterContentGroup marginBottom="none">
                    <StyledBox>
                      <Notification
                        heading={errorHeader}
                        sentiment="critical"
                        data-qa-id={dataQaIds.mayfairAccount.infoList}
                      >
                        <Paragraph>{errorSummary}</Paragraph>
                        <Text weight="bold">{stepsHeader}</Text>
                        <List marginBottom="none">
                          <ListItem icon={<>1.</>}>
                            <Link
                              href={stepOneHref}
                              external
                              event={LINK_EVENT.FILL_REGISTRATION_FORM}
                            >
                              {stepOne}
                            </Link>
                          </ListItem>
                          <ListItem icon={<>2.</>}>{stepTwo}</ListItem>
                          <ListItem icon={<>3.</>}>{stepThree}</ListItem>
                        </List>
                      </Notification>
                      <ButtonPattern marginBottom="none">
                        <Button href={backBtnHref} taggingLabel={backBtnLabel}>
                          {backBtnLabel}
                        </Button>
                      </ButtonPattern>
                    </StyledBox>
                  </StyledOuterContentGroup>
                </StyledGridItem>
              </Grid>
            </StyledContainer>
          </React.Fragment>
        ),
      )}
    </Container>
  );
}

export default MayfairAccountError;
